export default "/img/LI.60f54761ef4992a7f51619815da1ae72.png";